module.exports = __webpack_public_path__ + "b4ce478ff7503b4656d6d60c26b8beb2.svg";